import PropTypes from "prop-types";
import { useTheme } from "styled-components";

import {
  CardContainer,
  NoDataMessage,
} from "features/Strategy/v2/Detail/StrategyDetails.styles";
import { Title } from "style/components/Title.styles";
import { Tooltip } from "components/Tooltip";
import { getBrokerIcon } from "utils";
import { SupportedBrokersPlaceholder } from "./Placeholders/SupportedBrokersPlaceholder";

const SupportedBrokers = ({ supportedBrokers, isLoading }) => {
  const theme = useTheme();

  if (isLoading) {
    return <SupportedBrokersPlaceholder />;
  }

  return (
    <CardContainer className="secondary supported-brokers">
      <Title className="title mb-4">Supported brokers</Title>
      <div className="icon-wrapper">
        {supportedBrokers?.length > 0 ? (
          supportedBrokers.map((broker, i) => (
            <Tooltip
              placement="auto"
              value={broker.display_name}
              key={i}
              tooltipClassName="v2-tooltip"
            >
              <img
                src={getBrokerIcon(broker.square_logo_url, theme.mode)}
                className="m-1 supported-broker-icon"
              />
            </Tooltip>
          ))
        ) : (
          <NoDataMessage className="no-data">Not available</NoDataMessage>
        )}
      </div>
      <div className="divider mt-4 mb-0"></div>
    </CardContainer>
  );
};

SupportedBrokers.propTypes = {
  isLoading: PropTypes.bool,
  supportedBrokers: PropTypes.array,
};

export default SupportedBrokers;
